export default "__VITE_ASSET__eee97d51__"